export function formatDateToInput(value) {
  if (!value) return '';
  const date = new Date(value);
  if (isNaN(date)) return '';
  return date.toISOString().split('T')[0];
}